import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { Brand } from "@/models/Brands.model";
import { useBrandsStore } from "@/store/brands/brands.store";

export const useBrands = () => {
  const { brands, setBrands } = useBrandsStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);

    try {
      await collectionRef.Brands.get().then((querySnapshot) => {
        const data: Brand[] = [];
        querySnapshot.forEach((doc) => {
          const variation = doc.data() as Brand;
          const event = {
            ...variation,
            id: doc.id,
          } as Brand;
          data.push(event);
        });
        setBrands(data);
        setLoading(false);
      });
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!brands) {
      fetchData();
    }
  }, [brands]);

  return {
    data: brands,
    loading,
    error,
  };
};
